import styled, { createGlobalStyle, css } from 'styled-components';
import Typography from '../typography';

const clsPrefix = 'ui-modal';

export const modalClasses = {
  component: clsPrefix,
  header: `${clsPrefix}-header`,
  title: `${clsPrefix}-header-title`,
  closeBtn: `${clsPrefix}-close-btn`,
} as const;

const styles = css`
  .rc-dialog-close {
    display: none;
  }

  .rc-dialog-header {
    min-height: 64px;
    padding: 0;
    display: flex;
    align-items: center;
    /* stylelint-disable */
    border-radius: ${({ theme }) => `${theme.radius.medium}px ${theme.radius.medium}px 0 0`};
    /* stylelint-enable */
    overflow: hidden;

    background: ${({ theme }) => theme.color.surface.background};

    .rc-dialog-title {
      flex: 1;
      align-self: center;
    }

    .${modalClasses.header} {
      height: 100%;

      display: flex;
      align-items: center;
      justify-content: space-between;

      ${({ theme }) => theme.mappedTypography.h4.strong};
      color: ${({ theme }) => theme.color.tint.primary};

      .${modalClasses.title} {
        padding: 18px 24px;
      }

      .${modalClasses.closeBtn} {
        width: 64px;
        height: 64px;

        display: flex;
        align-items: center;
        justify-content: center;

        border: none;
        outline: none;
        background: none;

        transition: all 0.2s;
        cursor: pointer;

        &:hover {
          background-color: ${({ theme }) =>
            theme.createOverlayColor(theme.color.surface.background, 'hover')};
        }
      }
    }
  }

  .rc-dialog-content {
    border-radius: ${({ theme }) => theme.radius.medium}px;
    background-color: ${({ theme }) => theme.color.surface.modal};
  }

  .rc-dialog-body {
    padding: 24px;
  }

  .rc-dialog-footer {
    padding: 12px 24px;
    border-top: 1px solid ${({ theme }) => theme.color.border.emphasis};
  }
`;

export const ModalTitle = styled(Typography).attrs((p) => ({ ...p, display: 'h6' }))`
  margin-bottom: ${({ theme }) => theme.spacings.component.S}px;
`;
export const ModalDescription = styled(Typography).attrs((p) => ({ ...p, display: 'body2' }))`
  margin-bottom: ${({ theme }) => theme.spacings.component.S}px;
  color: ${({ theme }) => theme.color.tint.secondary};
`;

export const ModalStyles = createGlobalStyle`
  .rc-dialog-mask {
    z-index: 99998;
  }

  .rc-dialog-wrap {
    top: 60px !important;
    z-index: 99999;
  }

  .rc-dialog-mask {
    background: ${({ theme }) => theme.color.surface.backdrop} !important;

    .close-mask& {
      cursor: pointer;
    }
  }

  .rc-dialog-content {
    box-shadow: ${({ theme }) => theme.shadows.medium};
  }

  .${clsPrefix} {
    ${styles}
  }
`;
